import { Ng2StateDeclaration, StatesModule, Transition } from '@uirouter/angular';
import { FiStateNames } from '../../shared/fi-state-proxy/fi-state-names';
import { FiOnboardingAssignUsersComponent } from '@fi-app/fi-onboarding/fi-onboarding-synchronized/fi-onboarding-assign-users/fi-onboarding-assign-users.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiOnboardingSynchronizedService } from '@fi-app/fi-onboarding/fi-onboarding-synchronized/fi-onboarding-synchronized.service';
import { IOnboardingAssigneesItem } from '@fi-app/fi-onboarding/fi-onboarding-synchronized/fi-onboarding-synchronized';
import { isDefined } from '@fi-shared/utils';
import { coerceNumberProperty } from '@angular/cdk/coercion';

export const OnboardingAssignUsersState: Ng2StateDeclaration = {
    name: FiStateNames.Onboarding.AssignUsers,
    url: '/AssignUsers/{id:[0-9]+}',
    views: {
        '@Module': {
            component: FiOnboardingAssignUsersComponent,
        },
    },
    params: {
        onboardingAssigneesItem: undefined as IOnboardingAssigneesItem,
    },
    resolve: {
        onboardingAssigneesItem: [
            FiOnboardingSynchronizedService,
            FiStateService,
            Transition,
            (
                fiOnboardingSynchronizedService: FiOnboardingSynchronizedService,
                fiStateService: FiStateService,
                tr: Transition,
            ) => {
                const params = fiStateService.getParams(tr);
                const onboardingAssigneesItem: IOnboardingAssigneesItem = params.onboardingAssigneesItem;
                if (isDefined(onboardingAssigneesItem)) {
                    return onboardingAssigneesItem;
                }
                const onboardingId = coerceNumberProperty(params.id);
                return fiOnboardingSynchronizedService.getOnboardingAssigneesItem(onboardingId);
            },
        ],
    },
};

export const OnboardingSynchronizedStates: StatesModule = {
    states: [OnboardingAssignUsersState],
};
